import { useQuery } from '@tanstack/react-query';
import type { CourtHireBooking } from '@court-sync/shared';
import { courtHireService } from '@/services/courtHire';
import { STALE_TIME } from '@/queryClient';

function isActiveCourtHireBooking(status: CourtHireBooking['status']): boolean {
  return status === 'pending' || status === 'confirmed';
}

export function useCourtHireBookingsInRange(options: {
  clubId: string | undefined;
  from: string | undefined;
  to: string | undefined;
  enabled?: boolean;
}) {
  const { clubId, from, to, enabled = true } = options;
  const canFetch = Boolean(enabled && clubId && from && to);

  const { data, isLoading, error } = useQuery({
    queryKey: ['courtHireBookings', clubId, from, to],
    queryFn: async () => {
      const response = await courtHireService.getBookings(clubId!, { from, to });
      if (!response.success || !response.data) {
        throw new Error('Failed to load court hire bookings');
      }
      return response.data.filter((booking) => isActiveCourtHireBooking(booking.status));
    },
    enabled: canFetch,
    staleTime: STALE_TIME.SHORT,
  });

  return {
    bookings: data ?? [],
    isLoading,
    error: error instanceof Error ? error.message : error ? String(error) : null,
  };
}
